import { Alert, AlertColor, Snackbar } from '@mui/material';
import React, { useState } from 'react';

export const SnackbarLayout: React.FC<{
    message: string;
    variant: AlertColor;
    duration?: number;
    onDismiss: (id: number) => void;
    id: number;
}> = (props) => {
    const [open, setOpen] = useState(true);

    const handleDismiss = () => {
        setOpen(false);
        props.onDismiss(props.id);
    };

    return (
        open && (
            <Snackbar
                open={open}
                autoHideDuration={10000}
                onClose={handleDismiss}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={handleDismiss}
                    severity={props.variant}
                    sx={{ width: '100%', fontSize: '16px' }}
                >
                    {props.message}
                </Alert>
            </Snackbar>
        )
    );
};
